import { usePushNotificationInit } from '@features/notifications';

/**
 * Запускает watcher, который инициализирует push-уведомления
 * при первом входе пользователя в систему.
 *
 * Логика перенесена из entities/user (нарушение FSD entity→feature)
 * в features/notifications, согласно архитектуре FSD.
 */
export default defineNuxtPlugin(() => {
  usePushNotificationInit();
});
